export default "__VITE_ASSET__DxtpAD6P__"